import React, {PureComponent} from 'react';
import {
    ExpansionPanel,
    Typography,
    ExpansionPanelDetails,
    ExpansionPanelActions,
    ExpansionPanelSummary,
    Tooltip,
    Button, TextField,
    Snackbar,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core'
import Save from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import _ from 'lodash'
const dateFormat = "YYYY-MM-DDTHH:mm";

export default class TranslationComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            videoUrl: '',
            startTime: '',
            translationTime: 0,
            snackBarMessage: '',
            finishEventConfirm: false,
            clearAllConfirm: false,
            saveEventConfirm: false,

            eventName: '',
            eventDescription: '',
            eventUrl: '',
            imageUrl: '',
            eventDate: moment().format('YYYY-MM-DD'),
            errors: {}
        }
    }

    validate = () => {
        const errors = {};
        const {eventName, eventDescription} = this.state;
        if (!eventName) {
            errors.eventName = 'required'
        }
        if (!eventDescription) {
            errors.eventDescription = 'required'
        }
        this.setState({errors})
        return errors
    }

    componentDidUpdate(prevProps) {
        if (prevProps.translation && this.props.translation) {
            if (prevProps.translation.isStarted === false && this.props.translation.isStarted === true) {
                setInterval(
                    () => this.setState({translationTime: moment().diff(this.props.translation.startTime, 'seconds')}), 1000)
            }
        }
    }

    pad = (num) => {
        return ("0" + num).slice(-2);
    };

    hhmmss = (secs) => {
        let minutes = Math.floor(secs / 60);
        secs = secs % 60;
        const hours = Math.floor(minutes / 60)
        minutes = minutes % 60;
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
    }

    saveInfo = () => {
        const {setTranslationInfo} = this.props;
        const {videoUrl, startTime} = this.state;
        setTranslationInfo(videoUrl, startTime);
        this.setState({
            videoUrl: '',
            startTime: ''
        })
    };

    getSubheaderText = () => {
        const {translation} = this.props;
        if (!translation) {
            return ''
        }
        if (translation.isEnded) {
            return `status: ENDED. End time: ${translation.endTime}`
        }
        if (translation.isStarted) {
            return `status: STARTED. Time: ${this.hhmmss(this.state.translationTime)}`
        }
        if (!translation.isStarted && !translation.isEnded) {
            return `status: PENDING. Planned start time: ${translation.startTime}`
        }
    };

    hideSnackbar = () => {
        this.setState({snackBarMessage: ''})
    };

    onClearAll = async () => {
        await this.props.onClearAll();
        this.setState({snackBarMessage: "Cleared", clearAllConfirm: false})
    };
    onStart = async () => {
        await this.props.onStart();
        this.setState({snackBarMessage: "Event started"})
    };
    onStop = async () => {
        await this.props.onStop();
        this.setState({snackBarMessage: "Event finished", finishEventConfirm: false})
    };

    onSaveEvent = async () => {
        const {
            eventName,
            eventDescription,
            eventUrl,
            imageUrl,
            eventDate
        } = this.state;
        const errors = this.validate()
        if (_.isEmpty(errors)) {
            await this.props.onSave({
                eventName,
                eventDescription,
                eventUrl,
                imageUrl,
                eventDate
            });
            this.setState({snackBarMessage: "Event saved", saveEventConfirm: false})
        }

    };

    hideFinishDialog = () => {
        this.setState({finishEventConfirm: false})
    };
    openFinishDialog = () => {
        this.setState({finishEventConfirm: true})
    }

    openSaveDialog = () => {
        this.setState({saveEventConfirm: true})
    }
    hideSaveDialog = () => {
        this.setState({saveEventConfirm: false})
    }

    hideClearDialog = () => {
        this.setState({clearAllConfirm: false})
    };
    openClearDialog = () => {
        this.setState({clearAllConfirm: true})
    }

    render() {
        const {translation} = this.props;
        const {snackBarMessage, errors, saveEventConfirm, clearAllConfirm, finishEventConfirm} = this.state;
        return (
            <ExpansionPanel style={{width: '100%', borderRadius: 0}}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography style={{marginRight: 5}}>Live event settings</Typography>
                    <Typography style={{color: 'rgba(0, 0, 0, 0.54)'}}>{this.getSubheaderText()}</Typography>
                </ExpansionPanelSummary>
                {translation
                    ? <>
                        {/*<ExpansionPanelDetails style={{display: 'flex', flexDirection: 'row'}}>*/}
                            {/*<div style={{*/}
                                {/*display: 'flex',*/}
                                {/*width: '80%',*/}
                                {/*flexDirection: 'column',*/}
                                {/*justifyContent: 'flex-start'}}*/}
                            {/*>*/}
                                {/*<TextField*/}
                                    {/*id="date"*/}
                                    {/*label="Planned start"*/}
                                    {/*type="datetime-local"*/}
                                    {/*defaultValue={moment.utc(translation.startTime).format(dateFormat)}*/}
                                    {/*InputLabelProps={{*/}
                                        {/*shrink: true,*/}
                                    {/*}}*/}
                                    {/*onChange={(e) => this.setState({startTime: e.target.value})}*/}
                                {/*/>*/}
                                {/*<TextField*/}
                                {/*id="video"*/}
                                {/*label="Translation video url"*/}
                                {/*type="text"*/}
                                {/*defaultValue={translation.videoUrl}*/}
                                {/*InputLabelProps={{*/}
                                {/*shrink: true,*/}
                                {/*}}*/}
                                {/*onChange={(e) => this.setState({videoUrl: e.target.value})}*/}
                                {/*/>*/}
                            {/*</div>*/}
                            {/*<Tooltip title={"SAVE url and date"}>*/}
                                {/*<Button*/}
                                    {/*style={{height: 40}}*/}
                                    {/*variant="contained"*/}
                                    {/*color="default"*/}
                                    {/*startIcon={<Save/>}*/}
                                    {/*onClick={this.saveInfo}*/}
                                {/*>*/}
                                    {/*Save*/}
                                {/*</Button>*/}
                            {/*</Tooltip>*/}
                        {/*</ExpansionPanelDetails>*/}
                        <ExpansionPanelActions>
                            <Tooltip title={"START live event"}>
                                <span>
                                <Button onClick={this.onStart}
                                        disabled={!translation.videoUrl || translation.isStarted}>Start event</Button>
                                </span>
                            </Tooltip>
                            <Tooltip title={"Finish live event"}>
                                <span>
                                     <Button onClick={this.openFinishDialog}
                                             disabled={translation.isEnded || !translation.isStarted}>Finish event</Button>
                                </span>
                            </Tooltip>
                            <Tooltip title={"Finish live event"}>
                                <span>
                                     <Button onClick={this.openSaveDialog}>Save event</Button>
                                </span>
                            </Tooltip>
                            <Tooltip title={"Clear all data"}>
                                <Button onClick={this.openClearDialog}>CLEAR ALL</Button>
                            </Tooltip>
                        </ExpansionPanelActions>
                    </>
                    : null}
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={!!snackBarMessage}
                    autoHideDuration={4000}
                    onClose={this.hideSnackbar}
                    message={snackBarMessage}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={this.hideSnackbar}>
                                <CloseIcon fontSize="small"/>
                            </IconButton>
                        </React.Fragment>
                    }
                />
                <Dialog
                    open={finishEventConfirm}
                    onClose={this.hideFinishDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Finish event?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want finish event?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideFinishDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onStop} color="primary" autoFocus>
                            Finish
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={clearAllConfirm}
                    onClose={this.hideClearDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Clear data?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want clear data?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideClearDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onClearAll} color="primary" autoFocus>
                            Clear
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={saveEventConfirm}
                    onClose={this.hideSaveDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Save event"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Fill event data
                        </DialogContentText>
                        <TextField
                            error={!!errors.eventName}
                            helperText={errors.eventName}
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Event name"
                            type="text"
                            onChange={(e) => this.setState({eventName: e.target.value.trim()}, this.validate)}
                            fullWidth
                        />
                        <TextField
                            error={!!errors.eventDescription}
                            helperText={errors.eventDescription}
                            autoFocus
                            margin="dense"
                            id="description"
                            label="Event description"
                            type="text"
                            onChange={(e) => this.setState({eventDescription: e.target.value.trim()}, this.validate)}
                            fullWidth
                        />
                        <TextField
                            id="date"
                            label="Event date"
                            type="date"
                            defaultValue={moment().format('YYYY-MM-DD')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(e) => this.setState({eventDate: e.target.value})}
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="url"
                            label="Event url(optional)"
                            type="url"
                            onChange={(e) => this.setState({eventUrl: e.target.value.trim()})}
                            fullWidth
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="image"
                            label="Image url(optional)"
                            type="url"
                            onChange={(e) => this.setState({imageUrl: e.target.value.trim()})}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideSaveDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onSaveEvent} color="primary" autoFocus>
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            </ExpansionPanel>
        )
    }
}